import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.picker.GraphicalFamilyResourcePicker.';

  public static readonly history = `${Id.prefix}history`;
  public static readonly favourites = `${Id.prefix}favourites`;
  public static readonly categories = `${Id.prefix}categories`;
  public static readonly items = `${Id.prefix}items`;
  public static readonly resource = `${Id.prefix}resource`;
  public static readonly resourcePicker = `${Id.prefix}resourcePicker`;
}

export class LangGraphicalFamilyResourcePicker {
  private constructor() {}

  public static history(): string {
    return interpolate(Id.history);
  }
  public static favourites(): string {
    return interpolate(Id.favourites);
  }
  public static categories(): string {
    return interpolate(Id.categories);
  }
  public static items(): string {
    return interpolate(Id.items);
  }
  public static resource(): string {
    return interpolate(Id.resource);
  }
  public static resourcePicker(params: { resource: string }): string {
    return interpolate(Id.resourcePicker, params);
  }
}

export class GraphicalFamilyResourcePickerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.history, 'History', 'Label for history section');
    register.add(Id.favourites, 'Favourites', 'Label for favourites section');
    register.add(Id.categories, 'Categories', 'Label for categories section');
    register.add(Id.items, 'Items', 'Label for items section');
    register.add(Id.resource, "{{glossary 'resource'}}", 'Default resource glossary label');
    register.add(Id.resourcePicker, '{{resource}} Picker', 'Title for resource picker dialog');
  }
}
